import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: '', value: 'custom', align: 'center', sortable: false, width: '10', },
  { text: 'Nama', value: 'merchant_name' },
  { text: 'MID', value: 'mid' },
  { text: 'NMID', value: 'nmid' },
  { text: 'MPAN', value: 'mpan' },
  { text: 'Alamat Lengkap', value: 'address'},
  { text: 'Kode Pos', value: 'postal_code' },
  { text: 'Inputer', value: 'request_by' },
  { text: 'Approver 1', value: 'approver_1' },
  { text: 'Approver 2', value: 'approver_2' },
]);

export const search = {
  merchant_name: '',
  mid: '',
  nmid: '',
  mpan: '',
  address: '',
  postal_code: '',
  request_by: '',
};

export const dataMaxSelectedChangePic = 50;

export const dataDelayServiceHit = 500;

export const searchFields = [
  { model: "merchant_name", type: "text", label: "Nama",  },
  { model: "mid", type: "text", label: "MID",  },
  { model: "nmid", type: "text", label: "NMID",  },
  { model: "mpan", type: "text", label: "MPAN",  },
  { model: "address", type: "text", label: "Alamat Lengkap",  },
  { model: "postal_code", type: "text", label: "Kodepos",  },
];
